// #region imports

// --- Angular
import { Component, EventEmitter, Input, Output } from '@angular/core';

// --- 3rd Party
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

// --- HS Code
import { NotificationModel, NotificationTypes } from '../../../models';

// #endregion

@Component({
  selector: 'hs-notification-modal',
  templateUrl: './notification-modal.component.html',
  styleUrls: ['./notification-modal.component.scss'],
})
export class NotificationModalComponent {
  @Input() notificationsHeader: string = '';
  @Input() notifications: NotificationModel[] | null = new Array<NotificationModel>();
  @Input() markAsReadLabel: string = '';
  @Input() downloadLabel: string = '';
  @Input() modal: NgbModalRef | null = null;
  @Input() numberOfNewNotifications: number | null = 0;
  @Input() hasNotifications: boolean | null = false;
  @Input() reportIsDownLoading: boolean | null = false;

  @Output() viewNotification = new EventEmitter<NotificationModel>();
  @Output() removeNotification = new EventEmitter<NotificationModel>();

  onNotificationView(notification: NotificationModel): void {
    this.viewNotification.emit(notification);
  }

  onNotificationRemove(notification: NotificationModel): void {
    this.removeNotification.emit(notification);
  }
}
